<template>
    <div class="main-page-container">
        <!-- modals  -->
        <Modal :title="$t('preRegisteration.viewListSettings')" modalID="journeysColumns">
            <template>
                <ColumnsSwitcher :tableHeaders="getTableHeaders" url="journeys" modalID="journeysColumns" />
            </template>
        </Modal>
        <b-modal id="exportingProgress" hide-footer hide-header size="lg" :scrollable="false">
            <ExportProgress />
        </b-modal>
        <!-- header  -->
        <AlertFoundActiveSession />
        <PageHeader :title="title" :hasHeaderButton="true" class="page-top-header d-flex align-items-center vp-width-270 ">
            <template #headerButton>
                <router-link to=/add-journey>
                    <b-button pill class="d-flex align-items-center px-3 top-page-btn" variant="primary" size="sm" style="width: max-content">
                        <i class="bx bx-plus font-size-18 mr-2"></i> 
                         {{ $t('journeyBuilder.createJourney') }}
                    </b-button>
                </router-link>
            </template>
        </PageHeader>
        <section class="journey-grid" style="background-color:white; border-radius: 8px">
            <DxTreeList id="sitesAndAreasTreelist" :ref="journeysAndFlowsRefName" :data-source="allJourneys"
                :show-borders="false" :show-column-lines="true" :show-row-lines="true" :column-auto-width="true"
                :word-wrap-enabled="true" :allowColumnResizing="true" :rowAlternationEnabled="false"
                :repaint-changes-only="true" :two-way-binding-enabled="true" :expanded-row-keys="expandedRowKeys"
                :allow-column-reordering="true" key-expr="id" parent-id-expr="mod_Parent_ID"
                :class="{'journeyGridHeightWithAlert': getActiveSessionsCount, 'journeyGridHeight': !getActiveSessionsCount}"
                @content-ready="contentReady($event)" @editor-preparing="onEditorPreparing($event)"
                :rtl-enabled="rtlEnabled" @data-error-occurred="onDataErrorOccurred($event)">
                <DxStateStoring :enabled="true" type="custom" :customSave="customSave" :customLoad="customLoad"/>

                <DxHeaderFilter :visible="true" />
                <!-- <DxSelection mode="multiple" /> -->
                <DxColumnChooser :enabled="true" mode="select" :title="$t('common.grid.columnChooser')"/>
                <DxFilterRow :visible="true" />
                <DxLoadPanel :enabled="true"> </DxLoadPanel>

                <!-- start::Toolbar -->
                <DxToolbar>
                    <DxItem location="before" template="columnButtonTemplate" />
                    <!-- <DxItem template="exportButtonTemplate" location="before" /> -->
                    <DxItem template="clearAllTemplate" location="before" />
                </DxToolbar>
                <!-- end::Toolbar -->

                <!-- start::Pager -->
                <!-- <DxPaging :enabled="true" :page-size="10" /> -->
                <DxPager :visible="false" displayMode="full" :show-page-size-selector="false" :allowed-page-sizes="['all']"
                    :show-info="true" :show-navigation-buttons="true" :infoText="$t('common.page')"/>
                <!-- end::Pager -->

                <!-- start::scrolling -->
                <DxScrolling mode="standard" :scroll-by-content="rtlEnabled" :use-native="!rtlEnabled" />
                <!-- end::scrolling -->

                <!-- start::Column Button Template -->
                <template #columnButtonTemplate>
                    <button class="custom-columns cloumn-ml" @click="treelist.showColumnChooser()">
                        <span class="custom-text">{{ $t('common.grid.columns') }} </span>

                        <span class="custom-icon">            
                            <i class="dx-icon dx-icon-spindown dx-icon-right"></i>
                        </span>
                    </button>
                </template>
                <!-- end::Column Button Template -->

                <!-- start::Export Button -->
                <!-- <template #exportButtonTemplate class="export-dropdown">
                    <DxDropDownButton class="export-dropdown" :items="buttonData" @item-click="serverSideExport" text="Export" />
                </template> -->
                <!-- end::Export Button -->

                <!-- start::Clear All Button Template -->
                <template #clearAllTemplate>
                    <div v-if="showClearAll" class="clear-cols d-flex align-items-center">
                        <div class="custom-line"></div>
                        <Button :text="$t('common.grid.clearFilters')" @click="clearFilter" styling-mode="outlined" type="danger"
                            class="clear-CustomColums" />
                    </div>
                </template>
                <!-- end::Clear All Button Template -->

                <DxColumn data-field="sites" :caption="$t('common.sites')" :min-width="200" :allow-filtering="true" :allow-header-filtering="false"
                    :allow-reordering="false" />

                <DxColumn data-field="name" :caption="$t('common.name')" :allow-header-filtering="true" :min-width="250" :allow-filtering="true"
                    :allow-reordering="false" :filter-operations="allowedOperations" cssClass="overflow-wrap-anywhere" />

                <DxColumn :width="250" data-field="user_type" :caption="$t('common.userType')" :allow-filtering="false"
                    :allow-header-filtering="true" :calculate-cell-value="displayUserTypes" :header-filter="{
                        dataSource: userTypesDataSource
                    }" />

                <DxColumn :width="250" :caption="$t('common.input')" :allow-filtering="true" :allow-header-filtering="false"
                    :calculate-cell-value="displayInputs" />

                <DxColumn :width="250" :caption="$t('common.checks')" :allow-filtering="true" :allow-header-filtering="false"
                    :calculate-cell-value="displayChecks" />

                <DxColumn :width="250" :caption="$t('common.compliance')" :allow-filtering="true" :allow-header-filtering="false"
                    :calculate-cell-value="displayCompliances" />

                <DxColumn :width="250" :caption="$t('common.output')" :allow-filtering="true" :allow-header-filtering="false"
                    :calculate-cell-value="displayOutputs" />

                <DxColumn :width="250" :caption="$t('common.notification')" :allow-filtering="true" :allow-header-filtering="false"
                    :calculate-cell-value="displayNotifications" />

                <DxColumn :width="250" :caption="$t('common.feedback')" :allow-filtering="true" :allow-header-filtering="false"
                    :calculate-cell-value="displayFeedback" />

                <!-- start::Actions -->
                <DxColumn :min-width="150" alignment="left" id="custom-kioskDropDown"
                    css-class="select-actions custom-kioskDropDown" :caption="$t('common.grid.actions')" :width="200" :allow-filtering="false"
                    :allow-exporting="false" :allow-editing="false" :visible="true" cell-template="action-cell"
                    :allow-reordering="false">
                    <!-- <DxHeaderFilter :dataSource="customizeHeaderFilter" /> -->
                </DxColumn>

                <template #action-cell="{ data }">
                    <Actions :journeyData="data.data" @fetchJourneys="refreshJourneys" />
                </template>
                <!-- end::Actions -->
            </DxTreeList>
        </section>
    </div>
</template>
  
<script>
import { mapActions, mapGetters } from "vuex";
import PageHeader from "@/components/page-header";
import Actions from "@/components/journeyBuilder/ActionsForJourney";
import { journeyColumns } from "@/utils/dataSource";
import Modal from "@/components/modal/Modal";
import ColumnsSwitcher from "@/components/sharedCells/ColumnsSwitcher";
// import GridSettings from "@/components/grid/GridSettings";
import { exportExel } from "@/utils/mixins/exportMixin";
// import SearchInput from "@/components/journeyBuilder/SearchInput";
import { sliceLongString } from "@/utils/mixins/sliceLongString";
import AlertFoundActiveSession from "@/components/emergency/AlertFoundActiveSession";
import ExportProgress from "@/components/grid/ExportProgress";
// import DxDropDownButton from "devextreme-vue/drop-down-button";
import { default as Button } from "devextreme-vue/button";
import {
    DxTreeList,
    DxColumn,
    DxColumnChooser,
    DxHeaderFilter,
    DxToolbar,
    DxItem,
    DxFilterRow,
    // DxPaging,
    DxPager,
    DxScrolling,
    DxLoadPanel,
    //   DxSelection,
    //   DxLookup,
    DxStateStoring
} from "devextreme-vue/tree-list";

export default {
    title: "Journey Flows",
    name: "JourneysGrid",
    mixins: [exportExel, sliceLongString],
    components: {
        PageHeader,
        Actions,
        Modal,
        ColumnsSwitcher,
        ExportProgress,
        // GridSettings,
        // SearchInput,
        AlertFoundActiveSession,
        // DxDropDownButton,
        DxTreeList,
        DxColumn,
        DxColumnChooser,
        DxHeaderFilter,
        DxToolbar,
        DxItem,
        DxFilterRow,
        // DxPaging,
        DxPager,
        DxScrolling,
        DxLoadPanel,
        //   DxSelection,
        //   DxLookup,
        DxStateStoring,
        Button
    },
    data() {
        return {
            rtlEnabled : false,
            allJourneys: [],
            userTypesDataSource: [],
            buttonData: ["PDF", "Excel", "CSV"],
            journeysAndFlowsRefName: "journeysAndFlowsTreelist",
            expandedRowKeys: [1, 2],
            allowedOperations: ["contains"],
            showClearAll: false,
            columnsFilters: [],
            title: this.$t('journeyBuilder.grid.journey') +' / '+ this.$t('journeyBuilder.grid.flows'),
            showDetailIcon: false,
            limit: 10,
            currentPage: 1,
            arrowCollapse: false,
            InputTypes: [
                { id: "facial_recognition", name: "Facial Recognition" },
                { id: "rfid", name: "RFID" },
                { id: "qr_code", name: "QR Code" },
            ],
            outputs: [
                { id: "door_relay", name: "Door relay" },
                { id: "print_badge", name: "Print badge" },
                { id: "save_data", name: "Save data" },
            ],
            checks: [
                { id: "temperature_check", name: "Temperature" },
                { id: "mask_check", name: "Mask" },
            ],
            feedbacks: [
                { id: "audio_feedback", name: "Audio" },
                { id: "temperature_feedback", name: "Temperature" },
                { id: "light_feedback", name: "Light" },
            ],
            notifications: [
                { id: "temperature_alert", name: "Temperature Alert" },
                { id: "mask_alert", name: "Mask Alert" },
                { id: "compliance_alert", name: "Compliance Alert" },
            ],
        };
    },
    computed: {
        ...mapGetters("i18N",["getLanguage"]),
        ...mapGetters("grid", ["getSelectedRows", "getTableHeaders", "getExportProgessAppearance"]),
        ...mapGetters("emergency", ["getActiveSessionsCount"]),
        treelist() {
            return this.$refs[this.journeysAndFlowsRefName].instance;
        },
    },
    watch: {
        getExportProgessAppearance(value) {
            value && this.$bvModal.show("exportingProgress");
        },
    },
    methods: {
        ...mapActions("journeyBuilder", ["fetchJourneys"]),
        ...mapActions("journey", ["deleteJourney"]),
        ...mapActions("journeyFlow", ["deletejourneyFlow"]),
        ...mapActions("grid", [
            "createTableHeaders",
            "onTableHeader",
            "updateTableHeaders",
            "resetTableHeaders",
            "resetFilterValues",
            "onSetFilterValue",
            "exportJobBE"
        ]),
        async refreshJourneys() {
            this.fetchAllJourneys();
        },
        customizeHeaderFilter(options) {
            options.dataSource.postProcess = function (items) {
                items = items.filter((item) => item.value && item.value !== "-");
                if (this.pageIndex() === 0) {
                    items = items.slice(0);
                }
                return items;
            };
        },
        async customLoad() {
            if (this.userEmail !== "lt_techteam@visipoint.com") {
                await this.onTableHeader({
                    url: "/new-journeys",
                });
                let value = this.getTableHeaders;
                return value;
            }
        },
        customSave(gridState) {
            if (this.userEmail !== "lt_techteam@visipoint.com") {
                gridState.pageIndex = 0;
                gridState.pageSize = 1000000;
                let value = JSON.stringify(gridState);
                value = value.replace(',"selectedRowKeys":[]', "");
                this.formatingFilterArr(value);
                if (!this.getTableHeaders) {
                    this.createTableHeaders({
                        url: "/new-journeys",
                        headers: value,
                        filters: "[]",
                    });
                } else if (value != JSON.stringify(this.getTableHeaders)) {
                    this.updateTableHeaders({
                        url: "/new-journeys",
                        headers: value,
                        filters: "[]",
                    });
                }
                console.log("customSave values", value != JSON.stringify(this.getTableHeaders));
            }
        },
        formatingFilterArr(arr) {
            let columns = [];
            arr = JSON.parse(arr);
            arr.columns.map((obj) => {
                if (obj.name != 'Actions') {
                    delete obj.width;
                    delete obj.dataField;
                    delete obj.dataType;
                    delete obj.filterType;
                    columns.push(obj);
                }
            });
            columns.sort((a, b) => { return a.visibleIndex - b.visibleIndex; });
            console.log('columns', columns);
            this.columnsFilters = columns;
        },
        contentReady(e) {
            let sortedExp = this.getSortedColumns();
            console.log('sortedExp', sortedExp);
            let filterExp = e.component.getCombinedFilter();
            if (filterExp || sortedExp) {
                this.showClearAll = true;
            } else {
                this.showClearAll = false;
            }
            this.setColumnChooserPosition();
        },
        onEditorPreparing(e) {
            if (e.parentType == "filterRow") {
                e.editorOptions.placeholder = this.$t("common.grid.search");
            }
        },
        getSortedColumns() {
            let allColumns = Array.from(Array(this.treelist.columnCount()).keys()).map(index => this.treelist.columnOption(index));
            allColumns = allColumns.find(col => col.sortIndex != null);
            return allColumns;
        },
        setColumnChooserPosition() {
            var columnChooserView = this.treelist.getView("columnChooserView");

            if (!columnChooserView._popupContainer) {
                columnChooserView._initializePopupContainer();
                columnChooserView.render();
            }

            columnChooserView._popupContainer.option("position", {
                of: this.treelist.element(),
                my: this.rtlEnabled ? "right top" : "left top",
                at: this.rtlEnabled ? "right top" : "left top",
                offset: "0 50",
            });
        },
        clearFilter() {
            this.treelist.clearFilter("row");
            this.treelist.clearFilter("header");
            this.treelist.clearSorting();
        },
        serverSideExport(e) {
            this.exportJobBE({
                filterBy: this.columnsFilters,
                orderBy: "",
                type: e.itemData.toLowerCase(),
                gridName: "journey",
            });
        },
        displayUserTypes(e) {
            return e.user_type ? e.user_type.map(obj => obj.name).join(', ') : "-";
        },
        displayInputs(e) {
            return e.diagram ? e.diagram.nodes.find(node => node.type === "Input") ? e.diagram.nodes.find(node => node.type === "Input").label : '-' : "-";
        },
        displayChecks(e) {
            return e.diagram ? e.diagram.nodes.find(node => node.type === "Checks") ? e.diagram.nodes.find(node => node.type === "Checks").label : '-' : "-";
        },
        displayCompliances(e) {
            return e.diagram ? e.diagram.nodes.find(node => node.type === "Compliance") &&
             e.diagram.nodes.find(node => node.type === "Compliance").label.length > 0 ? e.diagram.nodes.find(node => node.type === "Compliance").label : '-' : "-";
        },
        displayOutputs(e) {
            return e.diagram ? e.diagram.nodes.find(node => node.type === "Output") ? e.diagram.nodes.find(node => node.type === "Output").label : '-' : "-";
        },
        displayNotifications(e) {
            return e.diagram ? e.diagram.nodes.find(node => node.type === "Notifications") ? e.diagram.nodes.find(node => node.type === "Notifications").label : '-' : "-";
        },
        displayFeedback(e) {
            return e.diagram ? e.diagram.nodes.find(node => node.type === "Feedback") ? e.diagram.nodes.find(node => node.type === "Feedback").label : '-' : "-";
        },
        toggle(row) {
            row.isCollapse = !row.isCollapse;
            this.$refs.table.toggleDetails(row);
        },
        onToggleVisible() {
            this.$bvModal.show("journeysColumns");
        },
        getJourneyInputValue(arr, inputValue) {
            const node =
                arr && arr.length > 0
                    ? arr.filter((input) => {
                        if (input.type == inputValue) {
                            return input.label;
                        }
                    })
                    : [];
            return node.length > 0 ? node[0].label : "-";
        },
        removeFirstElementOfArr(arr) {
            return arr.slice(1);
        },
        journeyType(id, type) {
            switch (type) {
                case "journey":
                    this.deleteJourney(id);
                    break;
                case "flow":
                    this.deletejourneyFlow(id);
                    break;
                default:
                    "";
                    break;
            }
        },
        fetchTableHeaders() {
            this.onTableHeader({
                url: "/new-journeys",
                headers: journeyColumns,
            });
        },
        updatePageRecords(value) {
            this.limit = value
        },
        fetchAllJourneys() {
            this.fetchJourneys().then((data) => {
                console.log('fetchAttendanceModes', data);
                this.allJourneys = data.data.map((journey) => {
                    return {
                        ...journey,
                        mod_Parent_ID: 0,
                    };
                });
                data.data.map((journey) => {
                    if (journey.journey_flows && journey.journey_flows.length > 0) {
                        journey.journey_flows.map((flow) => {
                            this.allJourneys.push({
                                ...flow,
                                mod_Parent_ID: journey.id,
                            });
                        });
                    }
                });
                // console.log("allJourneys", this.allJourneys);
                const arr = this.allJourneys.filter(journey => !!journey.user_type);
                const userTypes = Array.from(new Set(arr.map(item =>
                    item.user_type.map(obj => obj.name)
                ).flat()));
                this.userTypesDataSource = userTypes.map(name => (
                    {
                        text: name,
                        value: ['user_type', 'contains', name]
                    }
                ));
            });
        },
        onDataErrorOccurred(e){
            console.log('onDataErrorOccurred e', e);
            setTimeout(() => {  
                let errorRow = document.querySelector(".dx-treelist-headers .dx-error-message");  
                errorRow.innerHTML = this.$t('common.notes.anErrorOccurredGrid');  
            },100);
        },
    },
    mounted() {
        if (this.getLanguage == 'ar') {
            this.rtlEnabled = true;
        }
        this.fetchTableHeaders();
        // this.fetchJourneys();
        this.fetchAllJourneys();
    },
};
</script>

<style lang="scss" scoped>
.journey-grid {
    .toggle-icon {
        cursor: pointer;
        font-size: 1.5rem;
        line-height: 1.5rem;
    }

    .icon-warpper {
        display: flex;
        justify-content: center;
        height: 1.5rem;
        width: 1.5rem;
    }

    .is-expanded {
        transform: rotate(90deg);
        transition: transform 150ms ease-out, opacity 86ms ease-out,
            -webkit-transform 150ms ease-out;
    }
}
</style>

<style lang="scss">
.journeyGridHeight .dx-treelist-container {
    height: calc(100vh - 197px);
  }
  .journeyGridHeightWithAlert .dx-treelist-container {
    height: calc(100vh - 243px);
  }

  .overflow-wrap-anywhere{
    overflow-wrap: anywhere;
  }
</style>